import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import UIcon from "lib/icons/untitled_ui/UIcon";

type FilterPanelToggleProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  appliedFiltersCount?: number;
};

/**
 * Re-opens a collapsed filter panel. Renders nothing while the panel is open, so it can
 * sit permanently at the start of a results toolbar.
 */
function FilterPanelToggle({
  open,
  onOpenChange,
  appliedFiltersCount = 0,
}: FilterPanelToggleProps) {
  if (open) {
    return null;
  }
  return (
    <Button buttonType="secondary" onClick={() => onOpenChange(!open)} aria-label="Show filters">
      <UIcon icon="filterFunnel02" color="blue500" size={16} />
      {appliedFiltersCount > 0 && <AppliedFiltersCount>{appliedFiltersCount}</AppliedFiltersCount>}
    </Button>
  );
}

const AppliedFiltersCount = styled.span(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  backgroundColor: theme.colors.sysPrimaryDefault,
  width: "20px",
  padding: "0 4px",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "20px",
  color: theme.colors.sysTextWhite,
}));

export default FilterPanelToggle;
